import ApprovalsStep from './steps/ApprovalsStep';
import BasicsStep from './steps/BasicsStep';
import CommitStep from './steps/CommitStep';
import DatesStep from './steps/DatesStep';
import DeptsStep from './steps/DeptsStep';
import EventsStep from './steps/EventsStep';
import FuncStep from './steps/FuncStep';
import ModulesStep from './steps/ModulesStep';
import ProcStep from './steps/ProcStep';
import RadioStep from './steps/RadioStep';
import SessionsStep from './steps/SessionsStep';
import UploadStep from './steps/UploadStep';
import UsersStep from './steps/UsersStep';
import VenuesStep from './steps/VenuesStep';

/**
 * Step key to the page that renders it. The shell falls back to
 * StepPlaceholder for anything not listed here.
 */
const stepPages = {
    basics: BasicsStep,
    dates: DatesStep,
    modules: ModulesStep,
    func: FuncStep,
    commit: CommitStep,
    depts: DeptsStep,
    users: UsersStep,
    upload: UploadStep,
    proc: ProcStep,
    approvals: ApprovalsStep,
    radio: RadioStep,
    events: EventsStep,
    venues: VenuesStep,
    sessions: SessionsStep,
};

export default stepPages;
